import React from 'react'
import { Circle } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const OtherIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Circle cx='12' cy='12' r='9' stroke='currentColor' strokeWidth='2' />
            <Circle cx='7' cy='12' r='1.5' fill='currentColor' />
            <Circle cx='12' cy='12' r='1.5' fill='currentColor' />
            <Circle cx='17' cy='12' r='1.5' fill='currentColor' />
        </>
    ),
})

OtherIcon.displayName = 'OtherIcon'
